<template>
    <div class="answer-color-list-group">
        <design-2021-apprentice-multiselect-component
            class="with-border assignment-answer-color-list"
            id="assignment-show-answer-list-color"
            v-if="!common.isCreathlonProjec(groupTypeIdIn)"
            :placeholder="'Kies een kleur'"
            label="name"
            :multiple-select="false"
            :options="options"
            :selected-in="selectedColor"
            :disabled="isDisabled"
            @input="setColor($event)">
            <template
                slot="singleLabel"
                slot-scope="props">
                <div class="label">
                    <div
                        class="color-option"
                        :style="{ background: selector }"></div>
                    <div class="color-name">{{ props.option.name }}</div>
                </div>
            </template>

            <template
                slot="option"
                slot-scope="props">
                <div class="label">
                    <div
                        class="color-option"
                        :style="{ background: props.option.value }"></div>
                    <div class="color-name">{{ props.option.name }}</div>
                </div>
            </template>
        </design-2021-apprentice-multiselect-component>

        <b-form-radio-group
            class="apprentice-radiobutton"
            v-else
            v-model="selectedColor"
            stacked
            :id="`answer-radio-group-${partIn.id}`"
            :name="`answer-radio-group-${partIn.id}`"
            @change="setColor">
            <b-form-radio
                v-for="color in getColorOptions()"
                :key="color.id"
                :name="`answer-radio-i=tem-${color.id}`"
                :value="color">
                <span
                    class="color-legend"
                    :style="getBgColor(color)">
                </span>
                {{ color.text }}
            </b-form-radio>
        </b-form-radio-group>
    </div>
</template>

<script>
    import { Common as common } from '../../../../../../helpers/common';

    export default {
        name: 'design-2021-assignment-show-answer-list-color-component',
        props: ['partIn', 'itemId', 'canAnswer', 'projectId', 'isPreviewIn', 'groupTypeIdIn'],
        data() {
            return {
                selectedColor: this.getSelectedColor(),
                options: this.partIn.list_options.filter((option) => {
                    if (option.type === 2) {
                        option.name = this.getColorName(option.value);
                        return option;
                    }
                })
            };
        },
        computed: {
            common() {
                return common;
            },
            selector: function() {
                if (!this.selectedColor || this.selectedColor === 'Kies een kleur') {
                    return 'Kies een kleur';
                } else {
                    return this.selectedColor.value;
                }
            },
            isDisabled() {
                if (this.isPreviewIn) {
                    return false;
                } else {
                    return !this.canAnswer;
                }
            }
        },
        methods: {
            getSelectedColor() {
                if (this.partIn.hasAnswer()) {
                    const item = this.partIn.getAnswer().getListItem(this.itemId);

                    for (const option of this.partIn.list_options) {
                        if (item.option_id === option.id) {
                            return option;
                        }
                    }
                }

                return null;
            },

            getColorName: function(color) {
                if (color === '#f35958') {
                    return 'Rood';
                } else if (color === '#0acf97') {
                    return 'Groen';
                } else if (color === '#ffb548') {
                    return 'Oranje';
                } else if (color === '#007bff') {
                    return 'Blauw';
                } else if (color === 'Kies een kleur') {
                    return 'Kies een kleur';
                } else {
                    return 'Onbekend';
                }
            },

            setColor: function(option) {
                this.selectedColor = option;

                if (!this.partIn.hasAnswer()) {
                    const data = {
                        value: {
                            option_id: option.id,
                            item_id: this.itemId
                        },
                        part_id: this.partIn.id,
                        project_id: this.projectId
                    };

                    this.axios.post(this.routes.assignmentAnswer(), data).then(
                        (response) => {
                            this.partIn.addRelation('answers', response.data);
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        }
                    );
                } else {
                    const data = {
                        option_id: option.id,
                        item_id: this.itemId,
                        answer_id: this.partIn.getAnswer().id
                    };

                    if (!this.partIn.getAnswer().hasListItem(this.itemId)) {
                        // create list item answer
                        this.axios.post(this.routes.assignmentAnswerList(), data).then(
                            (response) => {
                                this.partIn.getAnswer().addRelation('list_items', response.data);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                    } else {
                        // update
                        this.axios
                            .post(
                                this.routes.assignmentAnswerListUpdate(this.partIn.getAnswer().getListItem(this.itemId).id),
                                data
                            )
                            .then(
                                (response) => {
                                    if (!response.data || !response.data.length) {
                                        this.partIn.getAnswer().getListItem(this.itemId).remove();
                                    } else {
                                        this.partIn.getAnswer().getListItem(this.itemId).update(response.data);
                                    }
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                }
                            );
                    }
                }
            },

            getColorOptions() {
                return this.partIn.list_options
                    .filter((option) => option.type === 2)
                    .map((option) => {
                        return {
                            text: option.name,
                            value: option.id,
                            id: option.id,
                            colorCode: option.value
                        };
                    });
            },

            getBgColor(color) {
                return {
                    '--legendBgColor': color.colorCode
                };
            }
        }
    };
</script>

<style scoped lang="scss">
    div.assignment-answer-color-list ::v-deep {
        width: 250px;
        border-radius: 4px;

        .multiselect__select {
            &:before {
                display: inline;
                top: 65%;
            }
        }

        .multiselect__tags {
            .multiselect__single {
                min-height: 10px;
                line-height: 1;
                vertical-align: middle;
            }
        }

        .label {
            display: flex;
            margin-bottom: 0;

            .color-option {
                height: 14px;
                width: 30px;
            }

            .color-name {
                width: 60px;
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    .color-legend {
        display: inline-block;
        height: 14px;
        width: 30px;
        background-color: var(--legendBgColor);
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }
</style>
